import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

import ModernPageLayout from "@/components/layout/ModernPageLayout";
import Tabs from "@/components/ui/v2/tabs";
import { ROUTES } from "@/constants/routes";

function InvoicesOverviewPage() {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs = [
    {
      id: "jobBoards",
      label: t("common.jobBoards"),
      href: `/${ROUTES.invoices}/${ROUTES.integrations}`,
      content: <></>,
    },
    {
      id: "channels",
      label: t("common.channels"),
      href: `/${ROUTES.invoices}/${ROUTES.channels}`,
      content: <></>,
    },
  ];

  const getActiveTabId = () => {
    const currentPath = location.pathname;
    if (currentPath.includes(`/${ROUTES.integrations}`)) {
      return "jobBoards";
    }
    if (currentPath.includes(`/${ROUTES.channels}`)) {
      return "channels";
    }
    return "jobBoards"; // default
  };

  return (
    <ModernPageLayout
      title={t("common.invoices")}
      subtitle={t("common.invoicesOverviewDescription")}
    >
      <div className="flex flex-col gap-8">
        <Tabs tabs={tabs} defaultTabId={getActiveTabId()} />
        <Outlet />
      </div>
    </ModernPageLayout>
  );
}

export default InvoicesOverviewPage;
